import React, { useState } from 'react'
import {
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Nav,
  TabContent,
  TabPane,
  NavItem,
  NavLink,
  Row,
} from 'reactstrap';
import toast, { Toaster } from 'react-hot-toast';
import { useFieldArray, useForm,Controller } from "react-hook-form";
import {
    useNavigate,
    useParams
  } from "react-router-dom";
import useSocialQuery from '../../../services/social';
import NavTabsItem from 'shared/components/Tabs';
interface IProps {

}

const EditSocial: React.FC<IProps>= () =>{
  const params = useParams();
  let navigate = useNavigate();

  const { data: Socials,isLoading } = useSocialQuery.useGetSingle(params.id)

  const [activeTab, setActiveTab] = useState('1');
  const { control, handleSubmit } = useForm();
  const { fields, append } = useFieldArray({
      control, // control props comes from useForm (optional: if you are using FormContext)
      name: "social", // unique name for your Field Array
  });
  React.useEffect(() => {
    if (Socials) {
    Socials.forEach((tm) => {
        append(tm);
      });
    }
  }, [Socials]);
  const onSuccessSubmit = () => {
    toast('Social updated', {
        duration: 2000,
        position: 'top-center',
        icon: '👍🏻',
      });
    setTimeout(() => {
        navigate(-1)
    }, 1000);
}
  
const {
  mutate: mutateSocialUpdate,
} = useSocialQuery.useUpdate(onSuccessSubmit);
const onSubmit = (data: any) => {
  const { social } =data
  social.map(
   (el:any)=>
    {
      delete el['unique_identifier']
    }
  )
  mutateSocialUpdate(social)
};

  return (
    <>
    {isLoading ? (
        <div>Loading...</div>
        ) : (
        <Card className="mt-3">
        <Toaster />
        <CardBody>
            <h4 className="header-title">Social</h4>
            <Form onSubmit={handleSubmit(onSubmit)}>
            <Nav tabs>
                {fields?.map((i: any, index) => (
                <>
                    <NavItem>
                    <NavLink
                        className={activeTab === `${index + 1}` ? "active" : ""}
                        onClick={function noRefCheck() {
                        setActiveTab(`${index + 1}`);
                        }}
                    >
                        <NavTabsItem item={i}/>
                    </NavLink>
                    </NavItem>
                </>
                ))}
            </Nav>
            <TabContent activeTab={activeTab}>
                {fields?.map((i: any, index) => (
                <TabPane tabId={(index + 1).toString()} key={i.id}>
                    <Row>
                    <Col sm="12">
                        <div>
                        <FormGroup row >
                                        <Label for="priority" sm={3}>
                                            Name
                                        </Label>
                                        <Col sm={9}>
                                        <Controller
                                            name={`social.${index}.priority`}
                                            control={control}
                                            render={({ field }) => (
                                            <Input {...field} type="number" id="priority" />
                                            )}
                                        />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row >
                                        <Label for="name" sm={3}>
                                            Name
                                        </Label>
                                        <Col sm={9}>
                                        <Controller
                                            name={`social.${index}.name`}
                                            control={control}
                                            render={({ field }) => (
                                            <Input {...field} type="text" id="name" />
                                            )}
                                        />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row >
                                        <Label for="url" sm={3}>
                                            Url
                                        </Label>
                                        <Col sm={9}>
                                        <Controller
                                            name={`social.${index}.url`}
                                            control={control}
                                            render={({ field }) => (
                                            <Input {...field} type="text" id="url" />
                                            )}
                                        />
                                        </Col>
                                    </FormGroup>
                                    
                        </div>
                    </Col>
                    </Row>
                </TabPane>
                ))}
            </TabContent>
            <Button color="primary" type="submit">
                Submit
            </Button>
            </Form>
        </CardBody>
        </Card>
    )}
    </>
  );
}

export default EditSocial